import { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { graficoIntervenciones } from "../../Api";
import { setTitlePage } from '../../Functions';

const EvolutionaryChart = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    let isMounted = true;
    setTitlePage('Gráfico Evolutivo de Prestaciones.');
    const getData = async () => {
      setLoading(true);
      let chart = [];
      const _response = await graficoIntervenciones({});
      const count = _response.data.count;
      chart = [
        ...chart,
        [
          "Element",
          "Monto Prestaciones",
          "Número de PAM de cirugía/procedimientos",
        ],
      ];
      _response.data.pagos.forEach((element) => {
        chart = [
          ...chart,
          [
            element.fecha,
            element.totalmes,
            element.totalpam,
          ],
        ];
      });
      if (isMounted) {
        setData(chart);
        setCount(count);
        setLoading(false);
      }
    };

    getData();

  }, []);

  const options = {
    chart: {
      title: "Total prestaciones",
      subtitle: "",
    },
    height: "auto",
    hAxis: {
      title: "",
      slantedText: true,
      slantedTextAngle: 30,
      logscale: true,
    },
    vAxis: {},
    vAxes: {
      0: {
        title: "Montos ($) prestaciones",
      },
      1: {
        title: "Número PAM ingresados",
        viewWindow: {
          max: 150,
        },
      },
      2: {
        viewWindow: {
          max: 150,
        },
      },
    },
    seriesType: "bars",
    series: {
      0: {
        axis: "montos",
        type: "bars",
        targetAxisIndex: 0,
      },
      1: {
        axis: "pams",
        type: "bars",
        targetAxisIndex: 1,
      },
      2: {
        axis: "visitas",
        type: "bars",
        targetAxisIndex: 2,
      },
    },
  };

  return (
    <>
      <div className="card py-3">
        <div className="card-body">
          <div className="border-bottom my-3 pb-2">
            <p>
              A continuación se presenta el gráfico de las prestaciones realizadas
              en los últimos 13 meses.
            </p>
          </div>
          {loading && (
            <div className="spinner text-center">
              Cargando ...
            </div>
          )}
          <div style={loading ? { display: "none" } : {}}>
            {count > 0 ? (
              <Chart
                chartType="ColumnChart"
                width="100%"
                height="700px"
                data={data}
                options={options}
              />
            ) : (
              <div className="text-center"> No hay datos registrados </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EvolutionaryChart;
